export default __webpack_public_path__ + "static/revolving_door_w.de38d05776fae85b0ffdbf39b1bf2404.png";